<template>
    <TriggerWithMenu class="ceo-change-download-button" ref="menu">
        <template #default>
            <button :class="buttonClass">{{ text }}</button>
        </template>
        <template #menu>
            <ul class="ceo-change-download-menu">
                <li @click.stop="download(type)" v-for="type in documentTypes" :key="type">{{ type }}</li>
            </ul>
        </template>
    </TriggerWithMenu>
</template>
<script>
import { request, Status } from '@/utils/request'

import TriggerWithMenu from '@/components/shared/trigger-with-menu'

export default {
    components: {
        TriggerWithMenu,
    },
    props: {
        report: {
            type: Object,
            required: true,
        },
        buttonClass: {
            type: String,
            default: 'primary small',
        },
        text: {
            type: String,
            required: false,
            default: 'Download',
        },
    },
    computed: {
        documentTypes() {
            return this.report.documentTypes.slice(0).sort((lhs, rhs) => -lhs.localeCompare(rhs))
        },
    },
    methods: {
        async download(title) {
            try {
                var response = await request(`/api/ceo-change-reports/${this.report.id}/${encodeURIComponent(title)}`)
                if (response.ok) {
                    this.showFile(
                        // This assumes report is a pdf which isnt great...
                        `${this.report.executive.colloquialName}-${title}.pdf`,
                        response.content,
                        response.contentType
                    )
                } else {
                    this.$flash('An issue occurred. Please try again later.', 'error')
                }
            } catch (response) {
                if (response.status == Status.TOO_MANY_REQUESTS) {
                    this.$flash(
                        'You’ve reached your download limit. Ready to commit to ManagementTrack? Contact sales.',
                        'error'
                    )
                } else {
                    this.$flash('An issue occurred. Please try again later.', 'error')
                }
            }
            this.$refs.menu.dismiss()
        },
        // https://blog.jayway.com/2017/07/13/open-pdf-downloaded-api-javascript/
        showFile(fileName, blob, contentType) {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([blob], { type: contentType })

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob)
                return
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob)
            var link = document.createElement('a')
            link.href = data
            link.download = fileName
            link.click()
            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data)
            }, 100)
        },
    },
}
</script>
<style>
.trigger-with-menu.ceo-change-download-button {
    .trigger-with-menu-menu {
        display: block;
        left: 60%;
        top: -200%;
        width: 250px;
    }

    li {
        cursor: pointer;
        text-align: left;
    }
}
</style>
